import { render, staticRenderFns } from "./Linkedin.vue?vue&type=template&id=0f158b69&scoped=true"
import script from "./Linkedin.vue?vue&type=script&lang=js"
export * from "./Linkedin.vue?vue&type=script&lang=js"
import style0 from "./Linkedin.vue?vue&type=style&index=0&id=0f158b69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f158b69",
  null
  
)

export default component.exports